/* Alleen verbetering van native links en formulier; verzenden blijft bij Shopify. */
(() => {
  if (window.vbmOverzetPage) return;
  window.vbmOverzetPage = true;
  const initialise = (scope) => {
    scope.querySelectorAll('[data-ov-status]').forEach((status) => {
      if (status.dataset.ovFocused) return;
      status.dataset.ovFocused = 'true';
      if (!window.Shopify?.designMode) status.focus();
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-ov-material]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const targetURL = new URL(link.href, window.location.href);
    if (targetURL.origin !== window.location.origin || targetURL.pathname !== window.location.pathname || !targetURL.hash) return;
    const target = document.getElementById(decodeURIComponent(targetURL.hash.slice(1)));
    const select = target?.querySelector('[data-ov-material-select]');
    if (!select) return;
    const option = Array.from(select.options).find((item) => item.dataset.material === link.dataset.ovMaterial);
    if (option) {
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
})();
